/**
 * 反调试工具函数集合
 */

/**
 * 主要的反调试功能
 */
export const enableAntiDebug = () => {
  // 方法1: 无限循环断点
  const createInfiniteDebugger = () => {
    setInterval(() => {
      Function("debugger")();
    }, 100);
  };

  // 方法2: 检测控制台是否打开
  const detectConsole = () => {
    let start = Date.now();
    debugger;
    if (Date.now() - start > 100) {
      // 如果执行时间超过100ms，说明可能是在调试模式下
      window.location.href = window.location.href;
    }
  };

  // 方法3: 检测开发者工具的打开
  const detectDevTools = () => {
    const checkDevTools = () => {
      const widthThreshold = window.outerWidth - window.innerWidth > 160;
      const heightThreshold = window.outerHeight - window.innerHeight > 160;
      if (widthThreshold || heightThreshold) {
        document.body.innerHTML = '请关闭开发者工具以继续使用本站';
      }
    };
    
    window.addEventListener('resize', checkDevTools);
    setInterval(checkDevTools, 1000);
  };

  // 启用所有方法
  createInfiniteDebugger();
  setInterval(detectConsole, 1000);
  detectDevTools();
};


/**
 * 禁用键盘快捷键 (F12, Ctrl+Shift+I, Ctrl+Shift+J等)
 */
export const disableDevToolsShortcuts = () => {
  document.addEventListener('keydown', (e) => {
    // F12
    if (e.keyCode === 123) {
      e.preventDefault();
      return false;
    }
    
    // Ctrl+Shift+I 或 Ctrl+Shift+J 或 Ctrl+Shift+C
    if (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) {
      e.preventDefault();
      return false;
    }
  });
};

export default {
  enableAntiDebug,
  disableDevToolsShortcuts
};